module.exports = __webpack_public_path__ + "img/icon_1.7e94a52e.png";